import type { TabProps as MuiTabProps } from '@mui/material'
import { Tab as MuiTab } from '@mui/material'

export interface Props<T extends string> extends Omit<MuiTabProps, 'value'> {
  value: T
}

const a11yProps = (value: string) => ({
  id: `simple-tab-${value}`,
  'aria-controls': `simple-tabpanel-${value}`,
})

const MuiTabWrapper = <T extends string>(props: Props<T>) => (
  <MuiTab {...a11yProps(props.value)} {...props} />
)

export default MuiTabWrapper
